import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import { Card, CardHeader, CardContent, Typography, Grid, Stack, Button, TextField } from '@mui/material';
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";

function Weekoff_viewscreen() {
   const [employeeData,setemployeeData] = useState([])
   const navigate = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id")
        
        if (id) {
            getInitData(id)
        }
       
    }, [])


    const getInitData = async (id) => {
      
        const query = `query getWeekoffById($id: String!) {
  weekoffById(id: $id) {  
    id
    location
    weekoffDays 
    startDate   
    endDate      
  }
} `;
        try {
         
            const response = await axios.post(BASEURL, {
                query: query,
                variables: { id },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            

            const weekoffRowdata = response.data.data.weekoffById
            setemployeeData(weekoffRowdata)
          
        } catch (error) {
            console.error('ResponseError:', error);
          
        }
    };


     function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB'); // This will return 'dd/mm/yyyy' format
      }

      const handleclose = ()=>{
        navigate('/employee-management')
      }
   
  return (
    <DashboardLayout>
    <Card>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold">
                Week Offs Details
              </Typography>
            </Stack>
          }
          
        />
        <CardContent>
          <Grid container spacing={1}  marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={4}>
              <Stack spacing={4}>
                <Typography  variant="h6" fontWeight="bold">Location: <span style={{color:"#67748E"}}>{employeeData.location}</span></Typography>
                <Typography  variant="h6" fontWeight="bold">Week Offs: <span style={{color:"#67748E"}}>{employeeData.weekoffDays}</span> </Typography>
            
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={4}>
              <Stack spacing={4}>
              <Typography variant="h6" fontWeight="bold">Valid From: <span style={{color:"#67748E"}}>{employeeData.startDate}</span> </Typography>
                <Typography variant="h6" fontWeight="bold">Valid Till: <span style={{color:"#67748E"}}>{employeeData.endDate}</span> </Typography>

              </Stack>
            </Grid>

            {/* Close Button */}
            <Grid item xs={12} textAlign="center" marginTop={2} sx={{marginLeft:"-11%"}}>
            <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleclose}
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        // disabled={
                        //     !handleActiveStep()
                        // }
                      >
                        Close
                        
                      </MaterialButton>
            </Grid>
          </Grid>
         
        </CardContent>
      </Card>
  </DashboardLayout>
  );
}

export default Weekoff_viewscreen;
